import type { MediatedCue } from '../api/schemas';

type CueBannerProps = {
  cue: MediatedCue | null | undefined;
  onAcknowledge: () => void;
  acknowledging?: boolean;
};

/**
 * The one moment of theater: Dale hands the counter the regular's secret.
 * Renders nothing when there's no cue to show, or while it's still loading.
 */
export function CueBanner({ cue, onAcknowledge, acknowledging = false }: CueBannerProps) {
  if (!cue) return null;

  return (
    <div role="note" className="cue">
      <p className="cue-label">Dale sabe</p>
      <p className="cue-phrase">{cue.message}</p>
      <div className="cue-actions">
        <button
          type="button"
          className="btn small secondary"
          onClick={onAcknowledge}
          disabled={acknowledging}
        >
          {acknowledging ? 'Guardando…' : 'Lo tengo'}
        </button>
      </div>
    </div>
  );
}
